import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { Tooltip } from 'antd';
import { getOrganisationList } from '../../../Redux/action/Organisation/OrganisationListAction';
import Beatloader from '../../../Common/Loaders/Beatloader';

const OrganizationMaster = ({ accessedModules, accessedPermission }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const [showLoader, setShowLoader] = useState(true);

    // to navigate back
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    useEffect(() => {
        if (token && user_id) {
            dispatch(getOrganisationList());
        } else {
            toast.error('Please login to continue.')
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id]);


    const { loadingOrganisationList, OrganisationListError, OrganisationList } = useSelector(state => state?.OrganisationListReducer);

    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Name", dataIndex: "Name", key: "Name" },
        { title: "Alias", dataIndex: "alias", key: "alias" },
        { title: "Entity Type", dataIndex: "EntityType", key: "EntityType" },
        { title: "Status", dataIndex: "Status", key: "Status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        if (loadingOrganisationList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (OrganisationList) {
            let arr = [];
            OrganisationList.map((val, i) => {
                arr.push({
                    key: "1", // Add a unique key for each row
                    SNo: i + 1,
                    Name: val?.name, // Ensure date formatting as neede
                    Alias: val?.alias,
                    EntityType: "Applicable",
                    Status:
                        <>
                            <span
                                className={`cursor-pointer  badge badge-pill badge-status bg-success`}>Active</span>
                        </>
                    ,
                    action: (
                        <div className="dropdown table-action">
                            <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                                <div className="dropdown-item cursor-pointer" onClick={() => { navigate(`/flexichain/organization/edit/${btoa(val?.id)}`) }} >
                                    <i className="ti ti-edit text-blue me-2"></i> Edit
                                </div>

                            </div>
                        </div>
                    )
                })
            });
            setDataSource(arr);
        }


    }, [loadingOrganisationList, OrganisationListError, OrganisationList])



    // const dataSource = [{
    //     key: "1", // Add a unique key for each row
    //     SNo: "1", // Changed to camelCase
    //     Name: "Commission", // Ensure date formatting as neede
    //     Code: "ChargeCategory",
    //     Prefix: "Applicable",
    //     CheckDigit: "Charge",
    //     AccountNo: "AE",
    //     HomePageURL: "xyz",
    //     TrackingURL: "xyz",
    //     Status:
    //         <>
    //             <span
    //                 className={`cursor-pointer  badge badge-pill badge-status bg-success`}>Active</span>
    //         </>
    //     ,
    //     action: (
    //         <div className="dropdown table-action">
    //             <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    //                 <i className="fa fa-ellipsis-v"></i>
    //             </Link>
    //             <div className="dropdown-menu dropdown-menu-right">
    //                 <div className="dropdown-item cursor-pointer" >
    //                     <i className="ti ti-edit text-blue me-2"></i> Edit
    //                 </div>

    //             </div>
    //         </div>
    //     )
    // },
    // {
    //     key: "1", // Add a unique key for each row
    //     SNo: "1", // Changed to camelCase
    //     Name: "Commission", // Ensure date formatting as neede
    //     Code: "ChargeCategory",
    //     Prefix: "Applicable",
    //     CheckDigit: "Charge",
    //     AccountNo: "AE",
    //     HomePageURL: "xyz",
    //     TrackingURL: "xyz",
    //     Status:
    //         <>
    //             <span
    //                 className={`cursor-pointer  badge badge-pill badge-status bg-danger`}>Inactive</span>
    //         </>
    //     ,
    //     action: (
    //         <div className="dropdown table-action">
    //             <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    //                 <i className="fa fa-ellipsis-v"></i>
    //             </Link>
    //             <div className="dropdown-menu dropdown-menu-right">
    //                 <div className="dropdown-item cursor-pointer">
    //                     <i className="ti ti-edit text-blue me-2"></i> Edit
    //                 </div>

    //             </div>
    //         </div>
    //     )
    // }]


    return (
        <>
            {showLoader ?
                <Beatloader />
                :
                <div className="page-wrapper">
                    <div className="content">
                        <div className="row">
                            <div className="col-md-12">
                                {/* Page Header */}
                                <div className="page-header">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h4 className="page-title">
                                                Organization List<span className="count-title">{OrganisationList.length}</span>
                                            </h4>
                                        </div>
                                        <div className="col-4 text-end">
                                            <div className="head-icons">
                                                <a
                                                    href="javascript:void(0);"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    data-bs-original-title="Collapse"
                                                    id="collapse-header"
                                                >
                                                    <i className="ti ti-chevrons-up" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Page Header */}
                            </div>
                        </div>
                        <div className="card">

                            <div className="card-body">

                                {/* Filter */}
                                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        <div className="dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                className="dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                            >
                                                <i className="ti ti-sort-ascending-2 me-2" />
                                                Sort{" "}
                                            </a>

                                            <div className="dropdown-menu  dropdown-menu-start">
                                                <ul>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Ascending
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Descending
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Recently Viewed
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-circle-chevron-right me-1" />
                                                            Recently Added
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search "
                                                name='search_by'
                                            // value={searchText}
                                            // onChange={(e) => setSearchText(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-sorts dropdown ms-2">
                                            <Tooltip placement="top" title="Filter">
                                                <a
                                                    href="javascript:void(0);"
                                                    data-bs-toggle="dropdown"
                                                    data-bs-auto-close="outside"
                                                    // className='py-1'
                                                    style={{
                                                        paddingTop: "7px",
                                                        paddingBottom: "6px"
                                                    }}
                                                >
                                                    <i className="ti ti-filter-share me-0" />
                                                    {/* Filter */}
                                                </a>
                                            </Tooltip>
                                            <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                                <div className="filter-set-view">

                                                    <table className="content-table">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">Name</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm ms-2"
                                                                        placeholder="Enter Name"
                                                                        name="request_no"
                                                                    />
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">Code</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm ms-2"
                                                                        placeholder="Enter Code"
                                                                        name="name"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">Prefix</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm ms-2"
                                                                        placeholder="Enter Prefix"
                                                                        name="email"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">CheckDigit</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm ms-2"
                                                                        placeholder="Enter CheckDigit"
                                                                        name="phone"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">Account No</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm ms-2"
                                                                        placeholder="Enter Account No"
                                                                        name="phone"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">Home Page URL</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm ms-2"
                                                                        placeholder="Enter Home Page URL"
                                                                        name="phone"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <label htmlFor="#">Tracking URL</label>
                                                                </td>
                                                                <td className="input_box_filter">
                                                                    {" "}
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm ms-2"
                                                                        placeholder="Enter Tracking URL"
                                                                        name="phone"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div className="filter-reset-btns">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <a className="btn btn-light">
                                                                    Reset
                                                                </a>
                                                            </div>
                                                            <div className="col-6">
                                                                <button type='submit' className="btn btn-primary w-100">
                                                                    Filter
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        <Tooltip placement="top" title="Print Data">
                                            <div
                                                className="btn btn-primary cursor-pointer me-2"
                                            >
                                                <i className="ti ti-printer text-white"></i>
                                            </div>
                                        </Tooltip>
                                        <Tooltip placement="top" title="Export Data">
                                            <div
                                                className="btn btn-primary cursor-pointer me-2"
                                            >
                                                <i className="fas fa-file-export text-white"></i>
                                            </div>
                                        </Tooltip>
                                        <button type='submit' className="btn btn-primary me-2">
                                            Search
                                        </button>
                                        <a
                                            className='btn btn-light me-2'
                                        >
                                            Clear
                                        </a>
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                            onClick={() => { navigate("/flexichain/organization-form") }}
                                        >
                                            <i className="ti ti-square-rounded-plus me-2" />
                                            Add Organization
                                        </div>
                                    </div>
                                </div>
                                {/* /Filter */}
                                {/* Contact List */}

                                <div className="table-responsive custom-table">
                                    <Table className="table datanew dataTable no-footer" pagination={false}
                                        dataSource={dataSource} columns={columns} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>}
        </>

    )
}

export default OrganizationMaster